import { format } from "date-fns";

import Loading from "componentsv2/widgets/Loading";
import CardInfo from "../CardInfo";
import CardHead from "./CardHead";
import CardList from "./CardList";
import BreakfastIcon from "components/Icons/Breakfast";
import { guests } from "./ctxCharts";
import proxy from "api/proxy";
import funcs from "tools/functions";

const fields_names = ["id"];

function Guests({ data }) {
  if (!data) {
    return (
      <CardInfo title="pending">
        <Loading />
      </CardInfo>
    );
  }

  async function printReportBreakfast() {
    console.log("clicked print Report Breakfast");
    const model = "hotel.service";
    const today = format(new Date(), "yyyy-MM-dd");
    const domain = [
      ["kind.category", "=", "breakfast"],
      ["service_date", "=", today],
    ];
    const { data } = await proxy.search(model, domain, fields_names);
    const reportName = "hotel.service";
    const { reportUrl, nameFile } = await proxy.report({
      report: reportName,
      data: {},
      records: [data[0].id],
    });
    funcs.createReportLink(reportUrl, nameFile);
  }

  const info = data.guests;
  const infoAdults = { ...guests.adults, ...info.adults };
  const infoChildren = { ...guests.children, ...info.children };

  return (
    <CardInfo title="guests" key="guests">
      <button
        id="breakfasts"
        type="button"
        className="flex bg-amber-200 w-full text-neutral-600 h-12 mt-8 rounded-xl px-4 py-2 border border-neutral-500 shadow-md shadow-neutral-300/50 cursor-pointer active:scale-95"
        onClick={printReportBreakfast}
      >
        <BreakfastIcon className="fill-current" />
        <span className="ml-4 my-auto">Breakfasts</span>
        <span className="ml-auto mr-0 font-bold my-auto">
          {info.breakfasts}
        </span>
      </button>
      <CardHead title="Total Guests" value={info.total_guests} />
      <CardList key="adults" item={infoAdults} />
      <CardList key="children" item={infoChildren} />
    </CardInfo>
  );
}

export default Guests;
